import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../../../store';
import './quick-start-modal.scss';
import { PolicyActionButtons } from '../policy-modal/policy-action-buttons';
import QuickStartBlockedItems from '../../wizard/policy-step/quick-start-blocked-items';

interface QuickStartModalContentProps {
    closeModal: () => void;
    setIsApply: (visible: boolean) => void;
}

export const QuickStartModalContent: React.FC<QuickStartModalContentProps> = observer(({
                                                                                           closeModal,
                                                                                           setIsApply
                                                                                       }) => {
    const { customerStore } = useStores();
    const [isLoading, setIsLoading] = useState(false);
    
    return <div className="policy-content">
        <div
            className="policy-title">Some notes before you apply your policy
        </div>
        <div className="policy-subtitle">
            These are the current best practice policies that AT&T recommends
            for customers to allow secure access between their networks and Internet.
            You can always customize this policy to meet your specific needs.
        </div>
        <QuickStartBlockedItems serviceLevel={customerStore.selectedLocation?.serviceLevel} />
        <PolicyActionButtons isLoading={isLoading}
                             setIsLoading={setIsLoading}
                             setIsApply={setIsApply}
                             closeModal={closeModal}
                             buttonLocation="quickStartModal"
                             />
    </div>;
});